const cc_ws_client = require('cc-client-sdk/lib/index.js');
const schema = require('cc-client-sdk/lib/schema.js');

module.exports = {
  cc_ws_client,
  schema,
};
